var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGridLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 98,
  height: 32,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M11.842 18.889h8.318v4.857c-1.09.976-3.01 1.905-5.537 1.905-5.06 0-7.962-3.603-7.962-9.885 0-5.993 2.956-9.57 7.918-9.57 2.752 0 5.009.76 7.106 2.393l1.106.86 3.64-4.9-1.02-.838C23.326 1.983 20.205 0 14.6 0 5.867 0 0 6.375 0 15.862 0 27.772 7.676 32 14.25 32c4.961 0 9.215-1.801 11.975-5.07l.326-.387v-13.56h-14.71v5.906z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M42.743.587c9.98 0 11.47 6.037 11.47 9.636 0 4.197-1.838 7.478-5.103 9.23L56.57 31.6h-7.434l-6.453-10.726h-4.47V31.6h-6.487V.587h11.017zm-.382 6.021h-4.147v8.215h4.951c2.753 0 4.332-1.543 4.332-4.236 0-2.387-.87-3.979-5.136-3.979z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M60.78.587h6.488v31.014H60.78z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M72.449.587h9.565c9.538 0 15.232 5.717 15.232 15.293 0 9.55-5.98 15.721-15.232 15.721H72.45V.587zm6.525 24.784h3.42c5.513 0 8.192-3.105 8.192-9.49 0-6.249-2.604-9.159-8.192-9.159h-3.42v18.649z",
  clipRule: "evenodd"
})));
export default SvgGridLogo;